import { updateEarlyWarningFlag } from '@/apis/addition'
import { t } from '@/plugins/i18n'
import { isJA } from '@/store'
import dayjs from 'dayjs'
import { ElMessage } from 'element-plus'
import { throttle } from 'lodash'
import { nextTick } from 'vue'
// TODO：供应商名称可以编辑
export const d2cproductColumns: any = [
  {
    label: t('商品情报'),
    prop: 'productInfo',
    align: 'center',
    slotName: 'productInfo',
    fixed: 'left',
    width: 80,
    ununcheck: true,
    wareHouseTypes: ['1', '2', '3']
  },
  {
    label: t('客户商品sku'),
    prop: 'customerProductMsku',
    align: 'center',
    slotName: 'customerProductMsku',
    fixed: 'left',
    width: 120,
    ununcheck: true,
    wareHouseTypes: ['1', '2', '3']
  },
  {
    label: t('客户商品规格'),
    prop: 'specification',
    align: 'center',
    slotName: 'specification',
    slotHeadName: 'specificationTitle',
    fixed: 'left',
    minWidth: 120,
    ununcheck: true,
    wareHouseTypes: ['1', '2', '3']
  },
  {
    label: t('产品规格'),
    prop: 'productPropertiesName',
    align: 'center',
    slotName: 'productPropertiesName',
    minWidth: 95,
    ununcheck: true,
    wareHouseTypes: ['1', '2', '3']
  },
  {
    label: t('平台商品SKU'),
    prop: 'productSku',
    align: 'center',
    slotName: 'productSku',
    minWidth: 120,
    wareHouseTypes: ['1', '2', '3']
  },
  {
    label: t('販売サイト商品名'),
    prop: 'thirdItemName',
    align: 'center',
    minWidth: 120,
    wareHouseTypes: ['1', '2', '3']
  },
  {
    label: t('可用库存'),
    prop: 'availableQuantity',
    align: 'center',
    slotName: 'availableQuantity',
    sortable: 'availableQuantity',
    minWidth: 110,
    slotHeadName: 'availableQuantityHeadD2c',
    wareHouseTypes: ['1', '2', '3']
  },
  {
    label: t('已锁定'),
    prop: 'lockQuantity',
    align: 'center',
    slotName: 'lockQuantity',
    sortable: 'lockQuantity',
    minWidth: 120,
    slotHeadName: 'lockQuantityHeadD2c',
    wareHouseTypes: ['1', '2', '3']
  },

  {
    label: t('处理中'),
    prop: 'pendingStorage1',
    align: 'center',
    slotName: 'pendingStorage1',
    minWidth: 160,
    slotHeadName: 'ProcessingProductsHeadD2c',
    wareHouseTypes: ['1', '2', '3']
  },
  {
    label: t('处理中明细'),
    prop: 'pendingStorage',
    align: 'center',
    // sortable: 'pendingStorage',
    minWidth: 300,
    slotHeadName: 'pendingStorageHeadD2c',
    slotName: 'pendingStorageSlot',
    className: 'product-father',
    wareHouseTypes: ['1', '2', '3'],
    children: [
      {
        label: t('等待采购'),
        prop: 'waitPurchaseNum',
        align: 'center',
        slotName: 'waitPurchaseNum',
        slotHeadName: 'waitPurchaseNumHead',
        // sortable: 'waitPurchaseNum',
        className: 'product-son',
        minWidth: 80,
        wareHouseTypes: ['1', '2']
      },
      {
        label: t('采购处理中'),
        prop: 'purchasingNum',
        align: 'center',
        slotName: 'purchasingNum',
        slotHeadName: 'purchasingNumHead',
        // sortable: 'purchasingNum',
        className: 'product-son',
        minWidth: 80,
        wareHouseTypes: ['1', '2']
      },
      {
        label: t('采购完成'),
        prop: 'purchasedNum',
        align: 'center',
        slotName: 'purchasedNum',
        slotHeadName: 'purchasedNumHead',
        // sortable: 'purchasedNum',
        className: 'product-son',
        minWidth: 80,
        wareHouseTypes: ['1', '2']
      },
      {
        label: t('国内运输中1'),
        prop: 'expressNum',
        align: 'center',
        slotName: 'expressNum',
        slotHeadName: 'expressNumHead',
        className: 'product-son',
        minWidth: 90,
        wareHouseTypes: ['1', '2', '3']
      },
      {
        label: t('已入库1'),
        prop: 'putInStorageNum',
        align: 'center',
        // slotName: 'putInStorageNum',
        slotHeadName: 'putInStorageNumHead',
        // sortable: 'putInStorageNum',
        className: 'product-son',
        minWidth: 80,
        wareHouseTypes: ['1', '2']
      },
      {
        label: t('质检中1'),
        prop: 'checkingNum',
        align: 'center',
        // slotName: 'checkingNum',
        slotHeadName: 'checkingNumHead',
        // sortable: 'checkingNum',
        className: 'product-son',
        minWidth: 80,
        wareHouseTypes: ['1', '2']
      },
      {
        label: t('异常处理中'),
        prop: 'exceptionNum',
        align: 'center',
        slotName: 'exceptionNum',
        slotHeadName: 'exceptionNumHead',
        // sortable: 'exceptionNum',
        className: 'product-son',
        minWidth: 90,
        wareHouseTypes: ['1', '2', '3']
      }
    ]
  },
  {
    label: t('待处理次品数'),
    prop: 'unableProcessDefectiveProducts',
    align: 'center',
    slotName: 'unableProcessDefectiveProducts',
    sortable: 'unableProcessDefectiveProducts',
    minWidth: 160,
    slotHeadName: 'unableProcessDefectiveProductsHeadD2c',
    wareHouseTypes: ['1', '2', '3']
  },
  {
    label: t('当前单价'),
    prop: 'unitPrice',
    align: 'center',
    slotName: 'unitPrice',
    minWidth: 95,
    wareHouseTypes: ['1', '2', '3']
  },
  {
    label: t('商品类型'),
    prop: 'productType',
    align: 'center',
    slotName: 'productType',
    minWidth: 80,
    wareHouseTypes: ['1', '2', '3']
  },
  {
    label: t('供应商信息'),
    prop: 'customSupplierName',
    align: 'center',
    slotName: 'customSupplierName',
    minWidth: 120,
    ununcheck: true,
    wareHouseTypes: ['1', '2', '3']
  },
  {
    label: t('商品采购国家'),
    prop: 'purchaseCountry',
    align: 'center',
    slotName: 'purchaseCountry',
    minWidth: 120,
    ununcheck: true,
    wareHouseTypes: ['1', '2', '3']
  },
  {
    label: t('保管费计费尺寸'),
    prop: 'volume',
    align: 'center',
    slotHeadName: 'volumeHead',
    minWidth: 100,
    wareHouseTypes: ['1', '2', '3']
  },
  {
    label: t('库龄'),
    prop: 'inventory',
    align: 'center',
    slotName: 'inventory',
    slotHeadName: 'inventoryHead',
    minWidth: 160,
    wareHouseTypes: ['1', '2', '3']
  }

]

export const b2bProductColumns: any = [
  {
    label: t('商品图片'),
    prop: 'productMainImg',
    align: 'center',
    fixed: 'left',
    slotName: 'productMainImg',
    className: 'product-gary',
    width: 80,
    // 不可取消勾选
    ununcheck: true
  },
  {
    label: t('客户商品sku'),
    prop: 'customerProductMsku',
    align: 'center',
    slotName: 'customerProductMsku',
    minWidth: 120,
    fixed: 'left',
    className: 'product-gary',
    // 不可取消勾选
    ununcheck: true
  },
  {
    label: t('客户商品规格'),
    prop: 'specification',
    align: 'center',
    slotName: 'specification',
    slotHeadName: 'specificationTitle',
    fixed: 'left',
    minWidth: 120,
    // excludes: ['ko'],
    ununcheck: true
  },
  {
    label: t('商品所在仓'),
    prop: 'goodsCountry',
    align: 'center',
    slotName: 'goodsCountry',
    fixed: 'left',
    minWidth: 120,
    // excludes: ['ko'],
    ununcheck: true
  },
  {
    label: t('商品名'),
    prop: 'productName',
    align: 'center',
    fixed: 'left',
    slotName: 'productName',
    minWidth: 120,
    className: 'product-gary',
    // 不可取消勾选
    ununcheck: true
  },
  {
    label: t('产品规格'),
    prop: 'productPropertiesName',
    align: 'center',
    slotName: 'productPropertiesName',
    className: 'product-gary',
    minWidth: 95,
    // 不可取消勾选
    ununcheck: true
  },
  {
    label: t('平台商品SKU'),
    prop: 'productSku',
    align: 'center',
    slotName: 'productSku',
    className: 'product-gary',
    minWidth: 120
  },
  {
    label: t('合计'),
    prop: 'amazonPredictTotalQuantity',
    align: 'center',
    slotName: 'amazonPredictTotalQuantity',
    slotHeadName: 'amazonPredictTotalQuantityTitle',
    className: 'product-white',
    minWidth: 80
    // fixed: 'right'
  },
  {
    label: t('平台库存'),
    align: 'center',
    // 需要唯一的prop
    prop: 'default1',
    className: 'product-father',
    slotHeadName: 'platformInventory',

    children: [{
      label: t('可用库存'),
      prop: 'availableQuantity',
      slotName: 'availableQuantity',
      slotHeadName: 'availableQuantityHead',
      align: 'center',
      sortable: 'availableQuantity',
      className: 'product-son red-set',
      minWidth: 100,
      isDefaultExpand: true
    },
    {
      label: t('已锁定'),
      prop: 'lockQuantity',
      slotName: 'lockQuantity',
      slotHeadName: 'lockQuantityHead',
      align: 'center',
      sortable: 'lockQuantity',
      className: 'product-son',
      minWidth: 100,
      isDefaultExpand: true
    },
    {
      label: t('次品'),
      prop: 'unableProcessDefectiveProducts',
      sortable: 'unableProcessDefectiveProducts',
      slotName: 'unableProcessDefectiveProducts',
      slotHeadName: 'unableProcessDefectiveProductsHead',
      align: 'center',
      minWidth: 130,
      className: 'product-son red-set',
      isDefaultExpand: true

    },
    {
      label: t('处理中1'),
      prop: 'pendingStorage',
      align: 'center',
      className: 'product-son',
      minWidth: 75,
      isDefaultExpand: true
    },
    {
      label: t('等待采购'),
      prop: 'waitPurchaseNum',
      align: 'center',
      slotName: 'waitPurchaseNum',
      slotHeadName: 'waitPurchaseNumHead',
      //   sortable: 'waitPurchaseNum',
      className: 'product-son',
      minWidth: 100,
      isDefaultExpand: false
    },
    {
      label: t('采购处理中'),
      prop: 'purchasingNum',
      align: 'center',
      slotName: 'purchasingNum',
      slotHeadName: 'purchasingNumHead',
      //   sortable: 'purchasingNum',
      className: 'product-son',
      minWidth: 125,
      isDefaultExpand: false
    },
    {
      label: t('采购完成'),
      prop: 'purchasedNum',
      align: 'center',
      slotName: 'purchasedNum',
      slotHeadName: 'purchasedNumHead',
      //   sortable: 'purchasedNum',
      className: 'product-son',
      minWidth: 100,
      isDefaultExpand: false
    },
    {
      label: t('国内运输中1'),
      prop: 'expressNum',
      align: 'center',
      //   slotName: 'expressNum',
      slotHeadName: 'expressNumHead',
      //   sortable: 'expressNum',
      className: 'product-son',
      minWidth: 125,
      isDefaultExpand: false
    },
    {
      label: t('已入库1'),
      prop: 'putInStorageNum',
      align: 'center',
      //   slotName: 'putInStorageNum',
      slotHeadName: 'putInStorageNumHead',
      //   sortable: 'putInStorageNum',
      className: 'product-son',
      minWidth: 75,
      isDefaultExpand: false
    },
    {
      label: t('质检中1'),
      prop: 'checkingNum',
      align: 'center',
      //   slotName: 'checkingNum',
      slotHeadName: 'checkingNumHead',
      //   sortable: 'checkingNum',
      className: 'product-son',
      minWidth: 75,
      isDefaultExpand: false
    },
    {
      label: t('异常处理中'),
      prop: 'exceptionNum',
      align: 'center',
      //   slotName: 'exceptionNum',
      slotHeadName: 'exceptionNumHead',
      //   sortable: 'exceptionNum',
      className: 'product-son',
      minWidth: 125,
      isDefaultExpand: false
    }

    ]
  },

  {
    label: t('Amazon 库存'),
    align: 'center',
    prop: 'default',
    isCrossMall: '0',
    className: 'product-amazon amazon-set amazon-td',
    children: [
      {
        label: t('Amazon 商品名称'),
        prop: 'amazonProductTitle',
        align: 'center',
        minWidth: 150,
        slotName: 'amazonProductTitle',
        className: 'product-blue amazon-set'
      },
      {
        label: t('可用库存'),
        prop: 'amazonSellQuantity',
        align: 'center',
        className: 'product-blue amazon-set',
        minWidth: 80
      },
      {
        label: t('待入库'),
        prop: 'amazonStockInQuantity',
        align: 'center',
        className: 'product-blue amazon-set blue-set',
        minWidth: 80
      },
      {
        label: t('不可用'),
        prop: 'amazonNotSellQuantity',
        align: 'center',
        className: 'product-blue amazon-set blue-set',
        minWidth: 80
      },
      {
        label: t('Amazon SKU'),
        prop: 'amazonMsku',
        align: 'center',
        className: 'product-blue amazon-set',
        slotName: 'amazonMsku',
        minWidth: 120
      },
      {
        label: t('FNSKU'),
        prop: 'overseaProducSku',
        align: 'center',
        minWidth: 120,
        slotName: 'overseaProducSku',
        className: 'product-blue amazon-set'
      }]
  },
  {
    label: 'CROSS MALL',
    align: 'center',
    prop: 'default',
    isCrossMall: '1',
    className: 'product-amazon amazon-set',
    children: [
      {
        label: '商品コード',
        prop: 'crossMallProductCode',
        align: 'center',
        minWidth: 150,
        slotName: 'crossMallProductCode',
        className: 'product-blue amazon-set'
      },
      {
        label: 'SKUコード',
        prop: 'crossMallProductSku',
        align: 'center',
        slotName: 'crossMallProductSku',
        className: 'product-blue amazon-set',
        minWidth: 80
      },
      {
        label: '商品名',
        prop: 'crossMallProductTitle',
        align: 'center',
        slotName: 'crossMallProductTitle',
        className: 'product-blue amazon-set blue-set',
        minWidth: 80
      },
      {
        label: '属性１名',
        prop: 'crossMallProp1',
        align: 'center',
        slotName: 'crossMallProp1',
        className: 'product-blue amazon-set blue-set',
        minWidth: 80
      },
      {
        label: '属性２名',
        prop: 'crossMallProp2',
        align: 'center',
        slotName: 'crossMallProp2',
        className: 'product-blue amazon-set',
        minWidth: 120
      },
      {
        label: '商品規格',
        prop: 'crossMallProductProp',
        align: 'center',
        minWidth: 120,
        slotName: 'crossMallProductProp',
        className: 'product-blue amazon-set'
      }]
  },
  {
    label: t('商品类型'),
    prop: 'productType',
    align: 'center',
    slotName: 'productType',
    minWidth: 80
  },
  {
    label: t('保管费计费尺寸'),
    prop: 'volume',
    align: 'center',
    slotHeadName: 'volumeHead',
    className: 'product-son red-set',
    minWidth: 100
  },
  {
    label: t('库龄'),
    prop: 'inventory',
    align: 'center',
    slotName: 'inventory',
    slotHeadName: 'inventoryHead',
    className: 'product-son red-set',
    minWidth: 140
  }

]

export const materialsColumns: any = [
  {
    label: t('辅料图片'),
    prop: 'ingredientsImg',
    align: 'center',
    slotName: 'ingredientsImg'
  },
  {
    label: t('辅料名称'),
    prop: 'ingredientsNameJp',
    align: 'center',
    minWidth: 230
  },
  {
    label: t('关联附加项'),
    prop: 'relatedFlag',
    align: 'center',
    slotName: 'relatedFlag',
    minWidth: 180
  },
  {
    label: t('辅料规格'),
    prop: 'materialsStyle',
    align: 'center',
    slotName: 'materialsStyle'
  },
  {
    label: t('辅料skuid'),
    prop: 'ingredientsSku',
    align: 'center',
    minWidth: 250
  },
  {
    label: t('处理中'),
    prop: 'noStockQuantity',
    sortable: 'no_stock_quantity',
    align: 'center',
    slotName: 'noStockQuantity',
    minWidth: 100
  },
  {
    label: t('锁定'),
    prop: 'lockQuantity',
    align: 'center',
    sortable: 'lock_quantity',
    slotName: 'lockQuantity',
    minWidth: 120
  },
  {
    label: t('可用库存'),
    prop: 'availableQuantity',
    align: 'center',
    slotName: 'availableQuantity',
    slotHeadName: 'availableQuantityHead',
    sortable: 'available_quantity',
    minWidth: 120
  },
  isJA() ? {
    label: t('是否提醒'),
    width: '120px',
    prop: 'notice',
    align: 'center',
    slotName: 'notice',
    event: throttle((row: any, bool: boolean) => {
      return updateEarlyWarningFlag({
        earlyWarningFlag: bool ? 0 : 1,
        ingredientsSku: row.ingredientsSku
      }).then(() => {
        row.earlyWarningFlag = bool ? 0 : 1
        ElMessage.success(bool ? t('设置成功，下次该辅料不再提醒') : t('设置成功'))
        return false
      })
    }, 700)
  } : undefined
].filter(v => v)

export const productTableConfig = {
  showSelection: true,
  showExpand: true,
  showHandler: true,
  setHeight: true,
  handlerConfig: {
    width: 260,
    // 操作栏的宽度
    handleWidth: 180,
    handlerHead: true,
    fixed: 'right'
  },
  rowKey: 'productSku',
  expandConfigId: 'combinationProductItemList'
}
export const b2bproductTableConfig = {
  showSelection: true,
  showExpand: true,
  showHandler: true,
  setHeight: true,
  rowKey: 'productSku',
  isCheckMemory: true,
  handlerConfig: {
    width: 240,
    // 操作栏的宽度
    handleWidth: 180,
    handlerHead: true,
    fixed: 'right'
  },
  expandConfigId: 'combinationProductItemList'
}

export const groupTableConfig = {
}
export const combinationColumns = [
  {
    label: t('商品情报'),
    prop: 'productInfo',
    align: 'center',
    slotName: 'productInfo'
  },
  // {
  //   label: t('商品名'),
  //   prop: 'productTitle',
  //   slotName: 'productTitle',
  //   align: 'center'
  // },
  {
    label: t('客户商品规格'),
    prop: 'specification',
    align: 'center',
    slotName: 'specification',
    slotHeadName: 'specificationTitle',
    minWidth: 120,
    excludes: ['ko'],
    ununcheck: true
  },
  {
    label: t('商品规格2'),
    prop: 'productPropertiesName',
    align: 'center',
    slotName: 'productPropertiesName'
  },
  {
    label: t('商品SKU'),
    prop: 'productSku',
    slotName: 'productSku',
    align: 'center'
  },
  {
    label: t('单品数量'),
    prop: 'unitNums',
    align: 'center'
  },
  {
    label: t('单品落单数'),
    prop: 'remainCombinationProductItemRespList',
    align: 'center',
    slotName: 'remainCombinationProductItemRespList'
  }, {
    label: t('单价2'),
    prop: 'productSellPrice',
    slotName: 'productSellPrice',
    align: 'center'
  }, {
    label: t('采购国家'),
    prop: 'purchaseCountry',
    align: 'center',
    slotName: 'purchaseCountry'
  }
]
export const materialsCanAddCart = (row: any) => dayjs(row.priceExpireTime).valueOf() > dayjs().valueOf() && !row.uploadFlag
export const materialsTableConfig = {
  showSelection: true,
  // showExpand: true,
  showHandler: true,
  setHeight: true,
  handlerConfig: {
    width: 300
  },
  selectable: (row: any) => materialsCanAddCart(row)
}

export const defectiveColums = [
  {
    label: t('序号'),
    prop: 'index',
    align: 'center'
  },
  {
    label: t('次品图'),
    prop: 'defectiveImg',
    align: 'center',
    minWidth: 180,
    slotName: 'defectiveImg'
  },
  {
    label: t('说明'),
    prop: 'defectiveRemark',
    minWidth: 250,
    slotName: 'defectiveRemark'
  }
]

export const defectiveTableConfig = {
  showHandler: true,
  setHeight: true,
  handlerConfig: {
    label: t('处理'),
    minWidth: 120,
    align: 'center'
  }
}

export const productTypeSnum: any = {
  1: t('普通商品'),
  2: t('OEM商品'),
  3: t('组合商品')
}

export const measureColumns: any = [
  {
    label: t('THE CKB订单编号'),
    prop: 'platformOrderNo',
    slotName: 'platformOrderNo',
    align: 'center'
  },
  {
    label: t('客户订单编号'),
    prop: 'customerOrderNo',
    align: 'center'
  },
  {
    label: t('商品图片'),
    prop: 'productMainImg',
    slotName: 'productMainImg',
    align: 'center'
  },
  {
    label: t('产品名称'),
    prop: 'productName',
    slotName: 'productName',
    align: 'center'
  },
  {
    label: t('平台商品SKU'),
    prop: 'productSku',
    slotName: 'productSku',
    align: 'center'
  },
  {
    label: t('客户商品SKU'),
    prop: 'customerProductMsku',
    align: 'center'
  },
  {
    label: t('实物图片'),
    prop: 'urls',
    align: 'center',
    slotName: 'urls',
    width: 120
  },
  {
    label: t('实物视频'),
    prop: 'videoUrl',
    align: 'center',
    slotName: 'videoUrl',
    width: 120,
    isWhiteUser: 1
  },
  {
    label: t('商品信息(CM)'),
    prop: 'productMeasureDtoList',
    align: 'center',
    slotName: 'productMeasureDtoList',
    width: 444
  }
]
